<template>
  <q-btn class="badge-danger btn tw-document-trigger-btn svg-container" @click="toggleShowControls" floating>
    <img src="@/assets/icons/history.svg" alt="" />
    <q-tooltip>{{ $t("order.tooltip.documentsHistory") }}</q-tooltip>
  </q-btn>
  <DocumentsHistoryDialog  v-if="toggleShow"/>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import store from "@/store";
import DocumentsHistoryDialog from "@/components/alert/DocumentsHistory/DocumentsHistoryDialog.vue";

@Options({
  components: { DocumentsHistoryDialog }
})
export default class DocumentsHistory extends Vue {

   toggleShowControls() {
    return store.dispatch('orderModule/toggleShowDocumentsHistory')
  }

  get toggleShow(){
  return store.state.orderModule.showDocumentsHistory
}



}
</script>

<style scoped>
.svg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Centre verticalement sur toute la hauteur de la page */
}
</style>
